import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { ITextFieldProps, TextField } from '../../../../ui';

export type PasswordProps = Partial<ITextFieldProps> & {
	validateConfirmation?: boolean;
	name?: string;
};

export const Password = ({
	validateConfirmation,
	name,
	...props
}: PasswordProps) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
		trigger,
	} = useFormContext();

	const triggerConfirmPassword = () => {
		if (validateConfirmation && errors.confirmPassword) {
			trigger('confirmPassword');
		}
	};

	const passwordName = name ?? 'password';

	return (
		<TextField
			type="password"
			label={t('user_form_password_label')}
			autoComplete={props.autoComplete}
			invalid={!!errors[passwordName]}
			error={errors[passwordName]?.message as string}
			{...register(passwordName, {
				onChange: () => {
					triggerConfirmPassword();
				},
			})}
			{...props}
		/>
	);
};
